import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

export default function Preloader() {
  const [done, setDone] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setDone(true), 1700);
    return () => clearTimeout(t);
  }, []);

  return (
    <AnimatePresence>
      {!done && (
        <motion.div
          data-testid="preloader"
          className="fixed inset-0 z-[100] bg-oxford flex flex-col items-center justify-center gap-6"
          exit={{ y: "-100%" }}
          transition={{ duration: 0.8, ease: [0.76, 0, 0.24, 1] }}
        >
          <motion.img
            src="/brand/isotipo-gold.webp"
            alt="BRIK Procurement Partners"
            className="w-16 h-16 sm:w-20 sm:h-20"
            initial={{ opacity: 0, scale: 0.85 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
          />
          <motion.span
            className="block h-px bg-gold"
            initial={{ width: 0 }}
            animate={{ width: 120 }}
            transition={{ duration: 1.1, delay: 0.3, ease: [0.16, 1, 0.3, 1] }}
          />
          <motion.span
            className="font-display text-[10px] font-semibold tracking-[0.4em] uppercase text-steel"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.6, delay: 0.5 }}
          >
            Better Buying. Better Business.
          </motion.span>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
